import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const MAX_ATTEMPTS = 5;
const POLL_INTERVAL = 2000;

/** Polls the donation checkout status endpoint until it resolves to a terminal
 * state (paid/expired/timeout/error), keeping DonateSuccess purely presentational. */
export function usePaymentStatusPolling(sessionId) {
  const [status, setStatus] = useState("checking"); // checking | paid | expired | timeout | error
  const [amount, setAmount] = useState(null);
  const [frequency, setFrequency] = useState("one_time");
  const attemptsRef = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      if (attemptsRef.current >= MAX_ATTEMPTS) {
        setStatus("timeout");
        return;
      }
      attemptsRef.current += 1;
      try {
        const { data } = await api.get(`/donations/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setAmount(data.amount);
          setFrequency(data.frequency || "one_time");
          setStatus("paid");
          return;
        }
        if (data.payment_status === "expired") {
          setStatus("expired");
          return;
        }
        setTimeout(poll, POLL_INTERVAL);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return { status, amount, frequency };
}
